import api from '@/api'

const state = {
  categories: [],
  loading: false,
  error: null
}

const getters = {
  allCategories: state => state.categories,
  isLoading: state => state.loading,
  getError: state => state.error
}

const actions = {
  async fetchCategories({ commit }) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getCategories()
      commit('SET_CATEGORIES', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createCategory({ commit }, categoryData) {
    try {
      commit('SET_LOADING', true)
      const response = await api.createCategory(categoryData)
      commit('ADD_CATEGORY', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateCategory({ commit }, { id, data }) {
    try {
      commit('SET_LOADING', true)
      const response = await api.updateCategory(id, data)
      commit('UPDATE_CATEGORY', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteCategory({ commit }, id) {
    try {
      commit('SET_LOADING', true)
      await api.deleteCategory(id)
      commit('REMOVE_CATEGORY', id)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_CATEGORIES(state, categories) {
    state.categories = categories
  },

  ADD_CATEGORY(state, category) {
    state.categories.push(category)
  },

  UPDATE_CATEGORY(state, updatedCategory) {
    const index = state.categories.findIndex(cat => cat.id === updatedCategory.id)
    if (index !== -1) {
      state.categories.splice(index, 1, updatedCategory)
    }
  },

  REMOVE_CATEGORY(state, id) {
    state.categories = state.categories.filter(cat => cat.id !== id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} 